import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';

import Theme from './components/Theme';
import Login from './components/Login';
import Alert from './components/Alert';
import PrivateRoute from './components/PrivateRoute';
import MenuBar from './components/MenuBar';
import LoadingModal from './components/LoadingModal';
import Service from './components/Service';

import './App.css';

class App extends Component {
	render() {
		const { alert, auth } = this.props;
		return (
			<Router>
				<MuiThemeProvider theme={Theme}>
					<CssBaseline />
					
					{ alert.message && <Alert {...alert} /> }

					{ auth.loggedIn && <MenuBar /> }
				
					<Switch>
						<PrivateRoute exact path="/" component={Service} />
						<Route path="/login" component={Login} />
					</Switch>

					<LoadingModal />

					<Typography variant="caption" align="center" style={{marginTop: Theme.spacing.unit}}>App by <a href="https://www.anycast.com.au/" target="_blank" rel="noopener noreferrer">Anycast</a></Typography>
				</MuiThemeProvider>
			</Router>
		);
	}
}

function mapStateToProps(state) {
	const { alert, auth } = state;
	return { alert, auth };
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js